import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="loading-spinner"></div>
  );
};

export default LoadingSpinner; 